/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = require("./lib/loader");



//////////////////
// WEBPACK FOOTER
// ./~/css-loader/index.js
// module id = 2480
// module chunks = 0